"use client";

import { c as _c } from "react/compiler-runtime";
import * as Sentry from "@sentry/nextjs";
import Error from "next/error";
import { useEffect } from "react";
export const metadata = {
  title: "Erreur - Dynabuy Clubs d'affaires",
  description: "Bienvenue sur la page d'erreur des clubs d'affaires de Dynabuy"
};
export default function GlobalError(t0) {
  const $ = _c(6);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      Sentry.captureException(error);
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2>Quelque chose s'est mal passé !</h2>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== reset) {
    t4 = <html><body>{t3}<button onClick={() => reset()}>Revenir à l'accueil</button></body></html>;
    $[4] = reset;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}